export const FIRST_INDEX = 0

export const TENANT_LOGO_DIMENSIONS = {
  HEIGHT: 90,
  WIDTH: 90
}

export const ROW_STYLE = 'flex flex-row justify-between mt-5'
export const COL_STYLE = 'flex flex-col space-y-3 w-3/6'
export const BOLD_WORDS = 'font-bold'
export const TENANT_PAGE_WRAPPER_CLASS = 'p-4 md:p-10 mx-auto max-w-9xl'
export const TENANT_PAGE_TITLE_CLASS = 'text-gray-500 my-4'

export const TENANT_SETTINGS_SECTIONS = {
  INFORMATION: 'Information',
  ONBOARDING: 'Onboarding',
  USER_STATUS: 'User Status',
  SURVEY: 'Survey',
  THEME: 'Theme',
  TUTORIAL: 'Tutorial',
  REFERRAL: 'Friend Referral',
  TRANSIT_VALIDATION: 'Transit Validation',
  ADDITIONAL_SETTINGS: 'Additional Settings'
}

export const TENANT_SECTIONS_TO_VALIDATE = {
  USER_STATUS: 'User Status',
  USER_STATUS_SUSPENDED: 'User Status Suspended',
  USER_STATUS_OPT_OUT_IN: 'User Status Opt Out/In',
  SURVEY: 'Survey',
  GENERAL_INFORMATION: 'General Information',
  TUTORIAL: 'Tutorial',
  THEME: 'Theme',
  SIGN_SCREEN: 'SignScreen',
  ONBOARDING_SIGN_IN: 'Onboarding Sign In',
  ONBOARDING_SIGN_UP: 'Onboarding Sign Up',
  ONBOARDING_WAITLIST: 'Onboarding Waitlist',
  ONBOARDING_PROVIDER_CONNECTION: 'Onboarding Provider Connection',
  SIGN_STEPS: 'Sign Steps',
  ADDITIONAL_INFO: 'Additional Information',
  REFERRAL: 'Referral',
  TRANSIT_VALIDATION: 'Transit Validation',
  TRANSIT_VALIDATION_PROGRAM_SETTINGS: 'Transit Validation Program Settings',
  TRANSIT_VALIDATION_PROGRAM_INFORMATION:
    'Transit Validation Program Information',
  NEW_TVD_ADMIN_USER: 'New TVD Admin User'
} as const

export const TENANT_COMMON_TITLES = {
  EDIT_INFO: 'Edit Information',
  EDIT_TRANSLATIONS: 'Edit Translations'
}

export const TENANT_TRANSLATION_STEP_TYPES = [
  'signUpScreenSteps',
  'signInScreenSteps',
  'tutorialSteps',
  'howDoesItWorkSteps'
]

export const SIGN_SCREEN_TYPE_TITLE = {
  SIGN_UP: 'Sign Up Screen',
  SIGN_IN: 'Sign In Screen'
}

export const TENANT_TRANSLATIONS_TITLES: TenantTranslationSections = {
  signInOrUp: {
    SignUpRewardEarningTitle: 'SignUp Reward Earning Title',
    SignUpWelcomeTitle: 'Welcome Dialog - Title',
    SignUpWelcomeDescription: 'Welcome Dialog - Description',
    SignUpWelcomeButtonLabel: 'Welcome Dialog - Button Label',
    SignUpScreenTitle: 'Sign Up Screen - Title',
    signUpScreenSteps: 'signUpScreenSteps',
    SignInScreenTitle: 'Sign In Screen - Title',
    signInScreenSteps: 'signInScreenSteps',
    WaitlistScreenTitle: 'Waitlist Screen - Title',
    WaitlistScreenSubtitle: 'Waitlist Screen - Subtitle',
    WaitlistScreenDescription: 'Waitlist Screen - Description',
    WaitlistScreenButtonLabel: 'Waitlist Screen - CTA Label',
    WaitlistScreenMessageTitle: 'Waitlist Screen - Added Mes. Title',
    WaitlistScreenMessageDescription: 'Waitlist Screen - Added Mes. Descrip.',
    ProviderConnectionScreenTitle: 'Provider Connect. Screen - Title',
    ProviderConnectionScreenSubtitle: 'Provider Connect. Screen - Subtitle',
    ProviderConnectionScreenDescription: 'Provider Connect. Screen - Desc.',
    ProviderConnectionCTALabel: 'Provider Connect. Screen - CTA Label'
  },
  userStatus: {
    SuspensionPageTitle: 'Suspended - Page Title',
    SuspensionPageDescription: 'Suspended - Page Description',
    OptBackInTitle: 'Opt Back In - Page Title',
    OptBackInSubTitle: 'Opt Back In - Subtitle',
    OptBackInDescription: 'Opt Back In - Page Description'
  },
  surveyInfo: {
    SurveyComingTitle: 'Survey Coming Soon - Title',
    SurveyComingDescription: 'Survey Coming Soon - Description',
    SurveyCongratulationsTitle: 'Survey Completed - Title',
    SurveyCongratulationsDescription: 'Survey Completed - Description',
    SurveyNotFoundTitle: 'Survey Not Found - Title',
    SurveyNotFoundDescription: 'Survey Not Found - Description'
  },
  tutorialInfo: { tutorialSteps: 'tutorialSteps' },
  additionalInfo: {
    ReactivationEarningTitle: 'Bonus Points Earning Title',
    ReactivationTitle: 'Reactivation Dialog - Title',
    ReactivationDescription: 'Reactivation Dialog - Description',
    ReactivationButtonLabel: 'Reactivation Dialog - Button Label',
    EarnEmptyScreenTitle: 'Earn Empty Screen - Title',
    EarnEmptyScreenDescription: 'Earn Empty Screen - Description',
    RedeemEmptyScreenTitle: 'Redeem Empty Screen - Title',
    RedeemEmptyScreenDescription: 'Redeem Empty Screen - Description',
    InviteCodeTitle: 'Rewards Code Screen - Title',
    InviteCodeDescription: 'Rewards Code Screen - Description',
    NotificationsScreenTitle: 'Notifications Screen - Title',
    NotificationsScreenDescription: 'Notifications Screen - Description',
    NotificationsEmailDescription: 'Email Component Description',
    NotificationsSMSDescription: 'SMS Component Description'
  },
  transitValidation: {
    TransitValidationCardTitle: 'Card Title',
    TransitValidationCardSubTitle: 'Card Subtitle'
  },
  friendReferral: {
    screenTitle: 'Screen Title',
    screenDescription: 'Screen Description',
    howDoesItWorkTitle: 'How does it Work - Title',
    howDoesItWorkSteps: 'howDoesItWorkSteps'
  }
}

export const TENANT = 'Tenant'
export const STEPS = 'Steps'
export const STEP = 'Step'
export const STEP_POSITION = 'StepPosition'
export const TITLE = 'Title'
export const STEP_TITLE = 'StepTitle'
export const DESCRIPTION = 'Description'
export const STEP_DESCRIPTION = 'StepDescription'

export const TENANT_STEP_TYPES_KEY_NAME = {
  SIGN_UP: 'signUpScreenSteps',
  SIGN_IN: 'signInScreenSteps',
  TUTORIAL: 'tutorialSteps',
  REFERRAL: 'howDoesItWorkSteps'
}

export const TUTORIAL_STEP_ID = 'TutorialStepsID'

export const TENANT_EVENT_TITLE = {
  UPDATE: 'Update Tenant Information',
  SELECT_EDIT: 'Select Edit Information'
}

export const TENANT_SETTINGS_PATHS = {
  INFORMATION: '/tenant-settings/general-information',
  INFORMATION_EDIT: '/tenant-settings/general-information/edit',
  ONBOARDING: '/tenant-settings/onboarding',
  ONBOARDING_SIGN_IN: '/tenant-settings/onboarding/sign-in/edit',
  ONBOARDING_SIGN_UP: '/tenant-settings/onboarding/sign-up/edit',
  ONBOARDING_WAITLIST: '/tenant-settings/onboarding/waitlist/edit',
  ONBOARDING_PROVIDER_CONNECTION:
    '/tenant-settings/onboarding/provider-connection/edit',
  ONBOARDING_TRANSLATIONS: '/tenant-settings/onboarding/translations/edit',
  USER_STATUS: '/tenant-settings/user-status',
  USER_STATUS_SUSPENDED: '/tenant-settings/user-status/suspended-status/edit',
  USER_STATUS_OPT_OUT_IN: '/tenant-settings/user-status/opt-out-opt-in/edit',
  USER_STATUS_TRANSLATIONS: '/tenant-settings/user-status/translations/edit',
  SURVEY: '/tenant-settings/survey',
  SURVEY_STATUS: '/tenant-settings/survey/survey-status/edit',
  SURVEY_TRANSLATIONS: '/tenant-settings/survey/translations/edit',
  TUTORIAL: '/tenant-settings/tutorial',
  TUTORIAL_STEPS: '/tenant-settings/tutorial/tutorial-steps/edit',
  TUTORIAL_TRANSLATIONS: '/tenant-settings/tutorial/translations/edit',
  THEME: '/tenant-settings/theme',
  THEME_EDIT: '/tenant-settings/theme/edit',
  REFERRAL: '/tenant-settings/friend-referral',
  REFERRAL_SETTINGS: '/tenant-settings/friend-referral/referral-settings/edit',
  REFERRAL_PAGE: '/tenant-settings/friend-referral/referral-page/edit',
  REFERRAL_TRANSLATIONS: '/tenant-settings/friend-referral/translations/edit',
  TRANSIT_VALIDATION: '/tenant-settings/transit-validation',
  TRANSIT_VALIDATION_PROGRAM_SETTINGS:
    '/tenant-settings/transit-validation/program-settings/edit',
  TRANSIT_VALIDATION_PROGRAM_INFORMATION:
    '/tenant-settings/transit-validation/program-information/edit',
  TRANSIT_VALIDATION_TRANSLATIONS:
    '/tenant-settings/transit-validation/translations/edit',
  ADDITIONAL_SETTINGS: '/tenant-settings/additional-information',
  ADDITIONAL_SETTINGS_EDIT: '/tenant-settings/additional-information/edit',
  ADDITIONAL_SETTINGS_TRANSLATIONS:
    '/tenant-settings/additional-information/translations/edit'
}

export const TENANT_EDIT_PAGE_TITLES = {
  GENERAL_INFORMATION: 'Edit Tenants General Information',
  ADDITIONAL_INFORMATION: 'Edit Tenants Additional Settings',
  THEME: 'Edit Tenants Theme Colors',
  FRIEND_REFERRAL: 'Edit Referral',
  ONBOARDING_TRANSLATIONS: 'Edit Sign In / Sign Up Translations',
  USER_STATUS_TRANSLATIONS: 'Edit User Status Translations',
  SURVEY_TRANSLATIONS: 'Edit Survey Translations',
  TUTORIAL_TRANSLATIONS: 'Edit Tutorial Translations',
  TRANSIT_VALIDATION_TRANSLATIONS: 'Edit Transit Validation Translations',
  FRIEND_REFERRAL_TRANSLATIONS: 'Edit Friend Referral Translations',
  ADDITIONAL_INFORMATION_TRANSLATIONS:
    'Edit Additional Information Translations'
} as const

export type TenantEditPageTitleKey = keyof typeof TENANT_EDIT_PAGE_TITLES

export const getTenantEditPageTitle = (key: TenantEditPageTitleKey): string => {
  return TENANT_EDIT_PAGE_TITLES[key]
}
